import { RoleEnum } from '/@/enums/userEnum'

export const MANAGER_ROLES = [
  RoleEnum.ADMIN,
  RoleEnum.ACCOUNT_MANAGER,
  RoleEnum.MSSP_MANAGER,
  RoleEnum.ORGANIZATION_MANAGER,
]

/**
 * System analyst user roles.
 */
export const ANALYST_ROLES = [RoleEnum.ADMIN, RoleEnum.ANALYST_USER]

export const MSSP_ROLES = [RoleEnum.MSSP_USER, RoleEnum.MSSP_MANAGER]

export const NORMAL_ROLES = [
  RoleEnum.ANALYST_USER,
  RoleEnum.ORGANIZATION_USER,
  RoleEnum.MSSP_USER,
]
